import { Button } from "@mui/material";
import LifecycleAdoptionDialog from "components/summary/success-plan/components/LifecycleAdoptionDialog";
import RevenueProfileDialog from "components/summary/success-plan/components/RevenueProfileDialog";
import SuccessPlanCard from "components/summary/success-plan/components/SuccessPlanCard";
import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import { useState } from "react";
import styles from "./SuccessPlan.module.scss";
import UsageSummarySection from "components/summary/success-plan/components/sections/UsageSummarySection";
import { AllInclusive, AttachMoney } from "@mui/icons-material";

type SuccessPlanProfileProps = {
  spState: SuccessPlanState;
};

const SuccessPlanProfile = ({ spState }: SuccessPlanProfileProps) => {
  const [openRevenueProfile, setOpenRevenueProfile] = useState(false);
  const [openLifecycleAdoption, setOpenLifecycleAdoption] = useState(false);

  const handleRevenuePrifileDialog = () => {
    setOpenRevenueProfile(true);
  };

  const handleLifecycleAdoptionDialog = () => {
    setOpenLifecycleAdoption(true);
  };

  return (
    <div className={styles["sp-profile"]}>
      <SuccessPlanCard titleSlot="Revenue Profile">
        <div>
          <Button
            onClick={handleRevenuePrifileDialog}
            disableRipple
            disableTouchRipple
            disableFocusRipple
            sx={{
              textTransform: "none",
              ":hover": { backgroundColor: "transparent" },
              fontSize: "12px",
            }}
            startIcon={<AttachMoney sx={{ width: 16, height: 16 }} />}
          >
            View Full Revenue Profile
          </Button>
        </div>
      </SuccessPlanCard>
      <SuccessPlanCard titleSlot="Lifecycle Adoption Summary">
        <div>
          <Button
            onClick={handleLifecycleAdoptionDialog}
            disableRipple
            disableTouchRipple
            disableFocusRipple
            sx={{
              textTransform: "none",
              ":hover": { backgroundColor: "transparent" },
              fontSize: "12px",
            }}
            startIcon={<AllInclusive sx={{ width: 16, height: 16 }} />}
          >
            View Lifecycle Adoption Engagement
          </Button>
        </div>
      </SuccessPlanCard>
      <UsageSummarySection spState={spState} />

      {openRevenueProfile && (
        <RevenueProfileDialog
          open={openRevenueProfile}
          onClose={() => setOpenRevenueProfile(false)}
          spState={spState}
        />
      )}
      {openLifecycleAdoption && (
        <LifecycleAdoptionDialog
          open={openLifecycleAdoption}
          onClose={() => setOpenLifecycleAdoption(false)}
          spState={spState}
        />
      )}
    </div>
  );
};

export default SuccessPlanProfile;
